import { Route, Routes } from 'react-router';
import NotFoundPage from '../pages/NotFoundPage';
import UserManagement from '../pages/user-management';
import UserList from '../pages/user-management/UserList/UserList';
import AddUser from '../pages/user-management/UserList/AddUser';
import ViewUser from '../pages/user-management/UserList/AddUser';
import EditUser from '../pages/user-management/UserList/AddUser';
import DepartmentList from '../pages/user-management/DepartmentList/DepartmentList';
import AddDepartment from '../pages/user-management/DepartmentList/AddDepartment';
import ImportDepartment from '../pages/user-management/DepartmentList/ImportDepartment';
import ViewDepartment from '../pages/user-management/DepartmentList/AddDepartment';
import EditDepartment from '../pages/user-management/DepartmentList/AddDepartment';

import {
    Policy,
    PrivacyDetail,
    HRDetail,
    RecruitmentDetail,
    HistoryPolicy,
    VendorDetail,
    CookieDetail,
    CCTVDetail,
    DataProcessingDetail,
    FreeFormDetail,
} from '../pages/policy';

import Profile from '../pages/user-profile/Profile';
import {
    DataFlowDetail,
    DataFlowDetailView,
    DataFlowList,
    DataFlowPreview,
    EditFlow,
    SyncData,
} from '../pages/data-flow';
import { RopaDetail, RopaDetailView, RopaList } from '../pages/ropa';
import { RiskAssessment, RiskAssessmentList } from '../pages/risk-assessment';
import Dashboard from '../pages/dashboard-inventory/Dashboard';
import { DCDPOView, DCDPOForm } from '../pages/dc-dpo';
import History from '../pages/risk-assessment/RiskAssessmentHistory/History';
import RiskRegisterHistory from '../pages/risk-register/RiskRegisterHistory/History';
import {
    RiskRegisterDetail,
    RiskRegisterForm,
    RiskRegisterList,
} from '../pages/risk-register';
import DashboardRiskManagement from '../pages/dashboard-risk/Dashboard';
import { DsRequestForm } from '../pages/ds-request-form';
import {
    MyCompany,
    AddCompany,
    DomainList,
} from '../pages/user-management/MyCompany';
import DashboardCookie from '../pages/dashboard-cookie/Dashboard';
import { DataCatalog } from '../pages/data-catalog';
import { CustomizeBanner } from '../pages/customize-banner';
import {
    CookieScanner,
    CookieScannerReport,
    ReportTable,
} from '../pages/cookie-scanner';
import { WorkflowDetail, WorkflowList } from '../pages/workflow';
import CookieCategory from '../pages/cookie-category';

import { MyTaskDetail, MyTaskList, MyTaskHistory } from '../pages/dsm-mytask';
import { Consent, ConsentHistory, ConsentForm } from '../pages/consent';
import { RiskAssessmentView } from '../pages/risk-register/RiskAssessmentView';
import DashboardDS from '../pages/dashboard-ds';
import { ROUTER } from '../constants/router';
import UpgradePlan from '../pages/upgrade-plan';
import ConsentDashboard from '../pages/dashboard-consent';
import ManageConsent from '../pages/manage-consent';
import DetailConsent from '../pages/manage-consent/DetailConsent';
import {
    TemplateConsent,
    TemplateList,
    TemplateTerm,
    TemplateHistory,
} from '../pages/template-design';
import ImportConsent from '../pages/import-consent';
import Metadata from '../pages/metadata';
import { DPIA, ListDPIA } from '../pages/dpia';
import Ifram from '../pages/user-management/ifram';
import Draw from '../pages/data-flow/Draw';
import EmailSetting from '../pages/email-setting';
import ImportDsRequest from '../pages/import-ds-request';
import ModalPage from '../pages/modal';
import DataInquiry from '../pages/data-inquiry';
import HistoryDetail from '../pages/data-flow/HistoryDetail';
import HistoryDetailRopa from '../pages/ropa/HistoryDetail';
import Yourplan from '../pages/yourplan';
import DataBreachForm from '../pages/data-breach/form';
import ResponsibilityList from '../pages/data-breach/responsibility';
import DataBreachLogList from '../pages/data-breach/log';
import DataBreachLogForm from '../pages/data-breach/log/form';
import EditForm from '../pages/data-breach/form/Edit';
import ImportUser from '../pages/user-management/UserList/ImportUser';
import ResponsibilityForm from '../pages/data-breach/responsibility/form';
import DashboardDataBreach from '../pages/data-breach/dashboard';
import Permissions from '../pages/user-management/Permission';

const PrivateRouteList = () => {
    return (
        <Routes>
            {/* my-task */}
            <Route path={ROUTER.DS_360.DASHBOARD} element={<DashboardDS />} />
            <Route path={ROUTER.DS_360.MY_TASK} element={<MyTaskList />} />
            <Route
                path={`${ROUTER.DS_360.MY_TASK}/:tab/:dsrTaskId`}
                element={<MyTaskDetail />}
            />
            <Route
                path={`${ROUTER.DS_360.MY_TASK}/:state/:historyId/history`}
                element={<MyTaskHistory />}
            />
            <Route
                path={`${ROUTER.DS_360.MY_TASK}/:tab/:dsrTaskId/:menu/:activityId/view`}
                element={<RopaDetailView />}
            />
            {/* Ds Request Form */}
            <Route
                path={ROUTER.DS_360.DS_REQUEST_FORM}
                element={<DsRequestForm />}
            />
            {/* Workflow */}
            <Route path={ROUTER.DS_360.WORKFLOW} element={<WorkflowList />} />
            <Route
                path={`${ROUTER.DS_360.WORKFLOW}/:workflowId`}
                element={<WorkflowDetail />}
            />
            {/* import DS request */}
            <Route
                path={`${ROUTER.DS_360.IMPORT_DS_REQUEST}`}
                element={<ImportDsRequest />}
            />
            {/* dashboard-inventory */}
            <Route
                path={ROUTER.DS_INVENTORY.DASHBOARD}
                element={<Dashboard />}
            />
            {/* Draw io */}
            <Route
                path={`${ROUTER.DS_INVENTORY.DATAFLOW}/:businessProcessId/draw`}
                element={<Draw />}
            />
            {/* Data Flow */}
            <Route
                path={`${ROUTER.DS_INVENTORY.DATAFLOW}/:businessProcessId/edit-flow`}
                element={<EditFlow />}
            />
            <Route
                path={`${ROUTER.DS_INVENTORY.DATAFLOW}/:businessProcessId`}
                element={<DataFlowDetail />}
            />
            <Route
                path={`${ROUTER.DS_INVENTORY.DATAFLOW}/:businessProcessId/view`}
                element={<DataFlowDetailView />}
            />
            <Route
                path={`${ROUTER.DS_INVENTORY.DATAFLOW}/:businessProcessId/preview`}
                element={<DataFlowPreview />}
            />
            <Route
                path={`${ROUTER.DS_INVENTORY.DATAFLOW}/sync/:businessProcessId/:departmentId`}
                element={<SyncData />}
            />
            <Route
                path={ROUTER.DS_INVENTORY.DATAFLOW}
                element={<DataFlowList />}
            />
            <Route
                path={`${ROUTER.DS_INVENTORY.DATAFLOW}/:businessProcessHistoryId/historyDetail`}
                element={<HistoryDetail />}
            />
            {/* RoPa */}
            <Route
                path={`${ROUTER.DS_INVENTORY.ROPA}/:activityId/view`}
                element={<RopaDetailView />}
            />
            <Route
                path={`${ROUTER.DS_INVENTORY.ROPA}/:activityId`}
                element={<RopaDetail />}
            />
            <Route path={ROUTER.DS_INVENTORY.ROPA} element={<RopaList />} />
            <Route
                path={`${ROUTER.DS_INVENTORY.ROPA}/:activityHistoryId/historyDetail`}
                element={<HistoryDetailRopa />}
            />

            {/* user-management */}
            <Route
                path={ROUTER.CONFIGURATION.USER_MANAGEMENT}
                element={<UserManagement />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`}
                element={<UserList />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/add-user`}
                element={<AddUser />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/view-user/:id`}
                element={<ViewUser />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/edit-user/:id`}
                element={<EditUser />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/import-user`}
                element={<ImportUser />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list`}
                element={<DepartmentList />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list/add-department`}
                element={<AddDepartment />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list/import-department`}
                element={<ImportDepartment />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/view-department/:id`}
                element={<ViewDepartment />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list/edit-department/:id`}
                element={<EditDepartment />}
            />

            {/* Permission */}
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/permissions`}
                element={<Permissions />}
            />

            {/* Upgrade Plan */}

            <Route
                path={ROUTER.CONFIGURATION.UPGRADE_PLAN}
                element={<UpgradePlan />}
            />

            {/* Policy */}

            <Route
                path={`${ROUTER.POLICY.HISTORY}/:historyId/:type`}
                element={<HistoryPolicy />}
            />

            <Route
                path={`${ROUTER.POLICY.PRIVACY_NOTICES}/:id`}
                element={<PrivacyDetail />}
            />
            <Route
                path={`${ROUTER.POLICY.HR_PRIVACY}/:id`}
                element={<HRDetail />}
            />
            <Route
                path={`${ROUTER.POLICY.VENDOR_PRIVACY}/:id`}
                element={<VendorDetail />}
            />

            <Route
                path={`${ROUTER.POLICY.COOKIE_PRIVACY}/:id`}
                element={<CookieDetail />}
            />

            <Route
                path={`${ROUTER.POLICY.CCTV_PRIVACY}/:id`}
                element={<CCTVDetail />}
            />

            <Route
                path={`${ROUTER.POLICY.RECRUITMENT_PRIVACY}/:id`}
                element={<RecruitmentDetail />}
            />

            <Route
                path={`${ROUTER.POLICY.DPA}/:id`}
                element={<DataProcessingDetail />}
            />
            <Route
                path={`${ROUTER.POLICY.FREE_FORM}/:id`}
                element={<FreeFormDetail />}
            />
            <Route path={ROUTER.POLICY.DEFAULT} element={<Policy />} />

            {/* User Profile */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/:mode" element={<Profile />} />

            {/* RiskManagementDashboard */}
            <Route
                path={ROUTER.RISK_MANAGEMENT.DASHBOARD}
                element={<DashboardRiskManagement />}
            />

            {/* Risk Assessment */}
            <Route
                path={ROUTER.RISK_MANAGEMENT.RA}
                element={<RiskAssessmentList />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RA}/:riskId`}
                element={<RiskAssessment />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RA}/:riskId/:view`}
                element={<RiskAssessment />}
            />

            {/* Risk Register กดดูจาก RA */}
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RA}/:menu/risk-register/:riskId`}
                element={<RiskRegisterDetail />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RA}/:menu/risk-register/:riskId/:id`}
                element={<RiskRegisterForm />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RA}/:menu/risk-register/:riskId/history`}
                element={<RiskRegisterHistory />}
            />

            {/* ROPA */}
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RA}/:menu/:activityId/view`}
                element={<RopaDetailView />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RA}/:riskAssessmentHistoryId/history`}
                element={<History />}
            />

            {/* RiskRegister */}
            <Route
                path={ROUTER.RISK_MANAGEMENT.RR}
                element={<RiskRegisterList />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RR}/:riskId`}
                element={<RiskRegisterDetail />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RR}/risk-assessment/:riskId`}
                element={<RiskAssessmentView />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RR}/:riskId/:id`}
                element={<RiskRegisterForm />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RR}/:riskId/history`}
                element={<RiskRegisterHistory />}
            />
            <Route
                path={`${ROUTER.RISK_MANAGEMENT.RR}/:menu/:activityId/view`}
                element={<RopaDetailView />}
            />

            {/* DC & DPO */}
            <Route path={ROUTER.CONFIGURATION.DC_DPO} element={<DCDPOView />} />
            <Route
                path={`${ROUTER.CONFIGURATION.DC_DPO}/:mode`}
                element={<DCDPOForm />}
            />

            {/* Data-Catalog */}
            <Route
                path={ROUTER.CONFIGURATION.DATA_CATALOG}
                element={<DataCatalog />}
            />

            {/* My-Company */}
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company`}
                element={<MyCompany />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company/create`}
                element={<AddCompany />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company/:id`}
                element={<AddCompany />}
            />
            <Route
                path={`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company/domain/:id`}
                element={<DomainList />}
            />
            {/* Cookie Management */}
            <Route
                path={ROUTER.COOKIE_MANAGEMENT.DASHBOARD}
                element={<DashboardCookie />}
            />
            <Route
                path={ROUTER.COOKIE_MANAGEMENT.CUSTOMIZE_BANNER}
                element={<CustomizeBanner />}
            />

            {/* Cookie Scanner */}
            <Route
                path={ROUTER.COOKIE_MANAGEMENT.COOKIE_SCANNER}
                element={<CookieScanner />}
            />
            <Route
                path={`${ROUTER.COOKIE_MANAGEMENT.COOKIE_SCANNER}/report/:domainId`}
                element={<CookieScannerReport />}
            />
            <Route
                path={`${ROUTER.COOKIE_MANAGEMENT.COOKIE_SCANNER}/report/:domainId/:categories`}
                element={<ReportTable />}
            />
            {/* Cookie Category */}
            <Route
                path={ROUTER.COOKIE_MANAGEMENT.COOKIE_CATEGORY}
                element={<CookieCategory />}
            />

            {/* Consent Management */}
            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.DASHBOARD}`}
                element={<ConsentDashboard />}
            />
            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.CONSENT}/:id`}
                element={<ConsentForm />}
            />
            <Route
                path={ROUTER.CONSENT_MANAGEMENT.CONSENT}
                element={<Consent />}
            />
            <Route
                path={ROUTER.CONSENT_MANAGEMENT.MANANGE_CONSENT}
                element={<ManageConsent />}
            />
            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.MANANGE_CONSENT}/:id`}
                element={<DetailConsent />}
            />
            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.CONSENT}/:historyId/history`}
                element={<ConsentHistory />}
            />
            {/* Template Design */}

            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}`}
                element={<TemplateList />}
            />
            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/term&condition/add`}
                element={<TemplateTerm />}
            />
            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/term%20&%20condition/:key`}
                element={<TemplateTerm />}
            />
            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/consent/add`}
                element={<TemplateConsent />}
            />

            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/consent/:key`}
                element={<TemplateConsent edit />}
            />

            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/:historyId/history`}
                element={<TemplateHistory />}
            />

            <Route
                path={`${ROUTER.CONSENT_MANAGEMENT.IMPORT_CONSENT}`}
                element={<ImportConsent />}
            />

            <Route
                path={`${ROUTER.DATA_CATALOG.METADATA}`}
                element={<Metadata />}
            />

            <Route path={`${ROUTER.DPIA.DEFAULT}`} element={<ListDPIA />} />
            <Route path={`${ROUTER.DPIA.DEFAULT}/:id`} element={<DPIA />} />

            <Route
                path={`${ROUTER.CONFIGURATION.DEFAULT}/iframe`}
                element={<Ifram />}
            />

            {/* Email Setting */}
            <Route
                path={`${ROUTER.CONFIGURATION.EMAIL_SETTING}`}
                element={<EmailSetting />}
            />

            {/* Your plan */}
            <Route
                path={`${ROUTER.CONFIGURATION.YOUR_PLAN}`}
                element={<Yourplan />}
            />

            {/* Data inquiry */}
            <Route
                path={`${ROUTER.DATA_INQUIRY.DEFAULT}`}
                element={<DataInquiry />}
            />

            {/* Data Breach */}
            <Route
                path={`${ROUTER.DATA_BREACH.DASHBOARD}`}
                element={<DashboardDataBreach />}
            />
            <Route
                path={`${ROUTER.DATA_BREACH.FORM}`}
                element={<DataBreachForm />}
            />

            <Route
                path={`${ROUTER.DATA_BREACH.EDIT_FORM}`}
                element={<EditForm />}
            />
            <Route
                path={`${ROUTER.DATA_BREACH.LOG}`}
                element={<DataBreachLogList />}
            />
            <Route
                path={`${ROUTER.DATA_BREACH.LOG_FORM}/:id`}
                element={<DataBreachLogForm />}
            />
            <Route
                path={`${ROUTER.DATA_BREACH.RESPONSIBILITY}`}
                element={<ResponsibilityList />}
            />
            <Route
                path={`${ROUTER.DATA_BREACH.RESPONSIBILITY_FORM}/:id`}
                element={<ResponsibilityForm />}
            />
            {/* not found */}
            <Route path="*" element={<NotFoundPage />} />

            {/* ModalPage */}
            <Route path="/ex-modal" element={<ModalPage />} />
        </Routes>
    );
};

export default PrivateRouteList;
